export default __webpack_public_path__ + "static/media/ic_arbitrum_96.4c6d42bf.svg";